import * as Yup from 'yup';
import { LeadForm } from './types';

export const initialValues: LeadForm = {
  jobDetails: '',
  timeframe: '',
  userName: '',
  email: '',
  phoneNumber: '',
  isAllowed: true,
};

export const validationSchema = Yup.object().shape({
  jobDetails: Yup.string().trim().required('The "I need help with..." field is required')
    .min(2, 'Minimal number of characters is 2')
    .test('max-words', 'Maximum number of words is 1000', (value) => {
      if (!value) return true;
      return value.trim().split(/\s+/).length <= 1000;
    }),
  timeframe: Yup.string().trim().required('The "My timeframe for this project is..." field is required')
    .min(2, 'Minimal number of characters is 2')
    .test('max-words', 'Maximum number of words is 1000', (value) => {
      if (!value) return true;
      return value.trim().split(/\s+/).length <= 1000;
    }),
  userName: Yup.string().required('Name is required')
    .min(2, 'Minimal number of characters is 2')
    .max(255, 'Maximum number of characters is 255'),
  email: Yup.string().required('Email is required')
    .nullable()
    .min(4, 'Minimal number of characters is 4')
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Value entered is not match format',
    ),
  phoneNumber: Yup.string().required('Phone Number is required')
    .nullable()
    .min(10, 'Minimal number of characters is 10')
    .matches(/^([0-9\s\-+()]*)$/, 'Value entered is not match format'),
});

export const STEPS = ['Overview', 'Timeframe', 'Contact Info', 'Success'];

export const inputProps = {
  style: {
    paddingLeft: 30,
  },
};
